import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Loader2, ShieldCheck } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { adminLogin } from '../lib/api';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [passcode, setPasscode] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!passcode) return;
    setSubmitting(true);
    try {
      await adminLogin(passcode);
      sessionStorage.setItem('lfl_admin_pass', passcode);
      toast.success('Welcome back');
      navigate('/admin/dashboard');
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Login failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="min-h-[70vh] bg-[#F8F2E4] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md bg-white border border-[#E8DCC0] rounded-2xl p-10 shadow-sm">
        <div className="w-14 h-14 rounded-xl bg-[#0F1B2D] text-[#E89530] flex items-center justify-center mb-6">
          <ShieldCheck className="w-6 h-6" strokeWidth={1.7} />
        </div>
        <p className="text-xs tracking-[0.25em] text-[#A36B1F] mb-2">ADMIN</p>
        <h1 className="font-serif-besley text-3xl text-[#0F1B2D] mb-2">Sign in</h1>
        <p className="text-sm text-[#5a5a5a] mb-8">Enter the team passcode to view incoming requests and messages.</p>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <Label className="text-[#0F1B2D]">Passcode</Label>
            <div className="relative mt-2">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#5a5a5a]" />
              <Input
                type="password"
                autoFocus
                value={passcode}
                onChange={(e) => setPasscode(e.target.value)}
                className="pl-10 h-11 border-[#E8DCC0] focus-visible:ring-[#2D4373]"
                placeholder="Enter passcode"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="btn-orange w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md text-sm font-medium disabled:opacity-70"
          >
            {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
            {submitting ? 'Verifying…' : 'Sign in'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default AdminLogin;
